export default __webpack_public_path__ + "static/media/download-button.0fa13e7d.svg";